namespace RioERP.Products {
    export namespace PermissionKeys {
        export const General = "Products:General";

        namespace ProductsManagement {
            export const Delete = "Products:ProductsManagement:Delete";
            export const Modify = "Products:ProductsManagement:Modify";
            export const View = "Products:ProductsManagement:View";
        }
    }
}
